import {Card, Stack, SwipeableDrawer, css, styled} from '@mui/material';
import {StyledBoxProps, StyledSwipeableDrawerProps} from './types';

export const DrawerRoot = styled('div')`
	background-color: ${({theme}) =>
		theme.palette.mode === 'light'
			? theme.palette.grey[100]
			: theme.palette.background.default};
`;

export const StyledSwipeableDrawer = styled(SwipeableDrawer)<StyledSwipeableDrawerProps>`
	${({$zIndex}) =>
		$zIndex &&
		css`
			z-index: ${$zIndex};
		`}

	& .MuiDrawer-paper {
		height: calc(60% - 56px);
		overflow: visible;
		max-height: calc(100dvh - 75px);

		${({$customHeight}) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`}

		${({$rounded}) =>
			$rounded &&
			css`
				border-top-left-radius: 8px;
				border-top-right-radius: 8px;
			`}
	}
`;

export const TouchPoint = styled(Stack)<StyledBoxProps>`
	display: none;
	${({$open}) =>
		$open &&
		css`
			display: flex;
		`}
	width: 30px;
	height: 6px;
	border-radius: 12px;
	${({theme}) => css`
		background-color: ${theme.colors.gray['30Percent']};
	`}
`;

export const StyledBox = styled(Card)<StyledBoxProps>`
	position: absolute;
	top: -56px;
	visibility: visible;
	right: 0;
	left: 0;
	background-color: ${({theme}) =>
		theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.grey[800]};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	border-radius: 8px 8px 0 0;
	padding: 16px;
	box-shadow: none;

	${({$open, theme}) =>
		$open &&
		css`
			top: -75px;
			& .MuiButton-textSizeSmall {
				color: ${theme.palette.text.primary};
				font-size: 1.25rem;

				& span {
					color: ${theme.palette.primary.main};
				}
			}
		`}
`;

export const Puller = styled('div')(({theme}) => ({
	width: 30,
	height: 6,
	backgroundColor: theme.colors.light.action.focus,
	borderRadius: 3,
}));
